/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import { Popover, PopoverBody } from "../libraries/reactstrap";
import { InView } from "react-intersection-observer";

import { BACKEND_CONFIG } from "../config/consts";
import getHelp from "../images/get-help.png";
import notificationBell from "../images/notification-bell.png";
import NotificationItem from "./NotificationItem";
import NotificationsModal from "./NotificationsModal";
import { ActivityLogConsumer } from "../context/activity-log-context";

import logo from "../images/logo-commercial-exchange.png";

class PageHeader extends React.Component {
  static userEmail;
  static agencyName;

  constructor(props) {
    super(props);

    this.state = {
      userEmail: null,
      agencyName: null,
      loggedOut: false,
      popoverOpen: false,
      isPopupVisible: false,
      expandedClientNumbers: [],
    };

    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    this.getUser();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.auth !== this.props.auth) {
      //TODO
      this.getUser();
    }

    if (this.props.auth && !prevProps.auth) {
      let unreadAgencyNotificationsCount =
        await this.props.loadUnreadAgencyNotificationsCount();
      if (unreadAgencyNotificationsCount > 0) {
        this.toggle(true);
      }
    }
  }

  isVisible() {
    return BACKEND_CONFIG.get("allstateAgencyFeaturesAllowed");
  }

  getUser() {
    if (!!this.props.allowUnauthorized) {
      return;
    }

    if (!!!this.props.auth) {
      return;
    }

    if (PageHeader.email && PageHeader.agencyName)
      this.setState({
        userEmail: PageHeader.userEmail,
        agencyName: PageHeader.agencyName,
        loggedOut: false,
      });
    else {
      axios
        .get(`${BACKEND_CONFIG.apiUrl}users`)
        .then((data) => {
          PageHeader.userEmail = data.data.agencyUserEmail;
          PageHeader.agencyName = data.data.agencyName;
          this.setState({
            userEmail: data.data.agencyUserEmail,
            agencyName: data.data.agencyName,
            loggedOut: false,
          });

          BACKEND_CONFIG.remove("quoteVersioningVisible");
          BACKEND_CONFIG.set(
            "quoteVersioningVisible",
            data.data.allstateQuoteVersioningVisible
          );

          BACKEND_CONFIG.remove("allstateAgencyFeaturesAllowed");
          BACKEND_CONFIG.set(
            "allstateAgencyFeaturesAllowed",
            data.data.allstateAgencyFeaturesAllowed
          );

          BACKEND_CONFIG.remove("allstateRequestExcessSurplusSuspenseVisible");
          BACKEND_CONFIG.set(
            "allstateRequestExcessSurplusSuspenseVisible",
            data.data.allstateRequestExcessSurplusSuspenseVisible
          );
        })
        .catch((error) => console.log(`Error: ${error.message}`));

      axios
        .get(`${BACKEND_CONFIG.apiUrl}account/environment-mode`)
        .then((response) => {
          BACKEND_CONFIG.remove("startApplicationPageComponent");
          BACKEND_CONFIG.set(
            "startApplicationPageComponent",
            response.data.StartApplicationPageComponent
          );

          BACKEND_CONFIG.remove("brandCode");
          BACKEND_CONFIG.set("brandCode", response.data.BrandCode);

          BACKEND_CONFIG.remove("busUnitId");
          BACKEND_CONFIG.set("busUnitId", response.data.BusUnitId);

          window.dispatchEvent(new Event("backendConfigChange"));
        });
    }
  }

  toggle = (newValue) => {
    const newState = newValue === true || !this.state.popoverOpen;

    if (!newState) {
      this.props.clearLoadedAgencyNotifications();
    }

    this.setState({
      popoverOpen: newState,
      expandedClientNumbers: [],
    });
  };

  toggleClient = (clientNotifications) => {
    if (this.isClientExpanded(clientNotifications)) {
      this.setState({
        expandedClientNumbers: this.state.expandedClientNumbers.filter(
          (clientNumber) => clientNumber !== clientNumber // TODO: Is this intended?
        ),
      });

      return;
    }

    this.setState({
      expandedClientNumbers: this.state.expandedClientNumbers.concat(
        clientNotifications.ClientNumber
      ),
    });
  };

  isClientExpanded = (clientNotifications) => {
    return this.state.expandedClientNumbers.includes(
      clientNotifications.ClientNumber
    );
  };

  render() {
    const { agencyName, userEmail, loggedOut } = this.state;

    return (
      <div>
        {loggedOut ? (
          <Redirect to="/login" />
        ) : (
          <div className="app-header">
            <Link to={"/"} className="header-logo">
              <img src={logo} alt="" />
            </Link>

            {!this.props.allowUnauthorized && this.props.auth ? (
              <>
                <div className="header-user-information">
                  <span className="header-agency-name">
                    {agencyName || ""} |&nbsp;
                  </span>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                  <a
                    href="#"
                    className="header-agency-log-off"
                    onClick={this.logout}
                  >
                    Log Out
                  </a>
                  <br />
                  <span className="agency-email-header">{userEmail || ""}</span>
                </div>
                <ActivityLogConsumer>
                  {(contextState) => {
                    let unreadAgencyNotificationsCount =
                      contextState.unreadAgencyNotificationsCount;
                    let loadedAgencyNotifications =
                      contextState.getAgencyNotifications();

                    return (
                      <Fragment>
                        <a
                          className="notification"
                          data-testid="notification-bell"
                          onClick={() => this.toggle()}
                        >
                          <img
                            src={notificationBell}
                            alt=""
                            id="notifications"
                            className="notification-icon"
                          />
                          {unreadAgencyNotificationsCount > 0 && (
                            <span
                              className={
                                "notification-number " +
                                (unreadAgencyNotificationsCount - 100 > 0
                                  ? unreadAgencyNotificationsCount - 1000 > 0
                                    ? "large"
                                    : "medium"
                                  : "")
                              }
                            >
                              {unreadAgencyNotificationsCount}
                            </span>
                          )}
                        </a>
                        <Popover
                          placement="bottom"
                          trigger="legacy"
                          hideArrow={true}
                          isOpen={this.state.popoverOpen}
                          target="notifications"
                          fade={false}
                          toggle={this.toggle}
                          offset={10}
                        >
                          <PopoverBody className={"notification-bar-wrapper"}>
                            <div className="notification-bar">
                              <div className="notifications-header">
                                <span className="title">Notifications</span>
                                <span className="details">
                                  <a
                                    style={{
                                      paddingRight: "10px",
                                      borderRight: "1px solid #636176",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        expandedClientNumbers:
                                          loadedAgencyNotifications.map(
                                            (clientNotifications) =>
                                              clientNotifications.ClientNumber
                                          ),
                                      });
                                    }}
                                  >
                                    Expand all
                                  </a>
                                  <a
                                    style={{ paddingLeft: "10px" }}
                                    onClick={() => {
                                      this.setState({
                                        expandedClientNumbers: [],
                                      });
                                    }}
                                  >
                                    Collapse all
                                  </a>
                                </span>
                              </div>
                              <div
                                className={
                                  "notification-body" +
                                  (Array.isArray(loadedAgencyNotifications) &&
                                    (loadedAgencyNotifications.length > 0
                                      ? ""
                                      : " empty"))
                                }
                              >
                                {loadedAgencyNotifications.length > 0 ||
                                  !contextState.allAgencyNotificationsLoaded ? (
                                  <Fragment>
                                    {loadedAgencyNotifications.map(
                                      (clientNotifications, index) => {
                                        return (
                                          <NotificationItem
                                            key={index}
                                            isClientExpanded={this.isClientExpanded(
                                              clientNotifications
                                            )}
                                            clientNotifications={
                                              clientNotifications
                                            }
                                            clearNotification={
                                              contextState.clearNotification
                                            }
                                            readNotification={
                                              contextState.readNotification
                                            }
                                            loadAgencyClientNotifications={
                                              contextState.loadAgencyClientNotifications
                                            }
                                            readClientAction={(
                                              clientId,
                                              notReadEventsCount
                                            ) => {
                                              this.setState({
                                                popupText: notReadEventsCount
                                                  ? "mark ALL as unread"
                                                  : "mark ALL as read",
                                                isPopupVisible: true,
                                                popupYesAction:
                                                  notReadEventsCount
                                                    ? () =>
                                                      contextState.readClientNotifications(
                                                        clientId,
                                                        false
                                                      )
                                                    : () =>
                                                      contextState.readClientNotifications(
                                                        clientId,
                                                        true
                                                      ),
                                              });
                                            }}
                                            clearClientAction={(clientId) => {
                                              this.setState({
                                                popupText: "clear all",
                                                isPopupVisible: true,
                                                popupYesAction: () =>
                                                  contextState.clearClientNotifications(
                                                    clientId
                                                  ),
                                              });
                                            }}
                                            closeActiveHub={() =>
                                              this.toggle(false)
                                            }
                                            toggle={() =>
                                              this.toggleClient(
                                                clientNotifications
                                              )
                                            }
                                          />
                                        );
                                      }
                                    )}
                                    {!contextState.allAgencyNotificationsLoaded && (
                                      <InView
                                        onChange={(inView) => {
                                          if (inView && contextState.ready) {
                                            contextState.loadMoreAgencyNotifications();
                                          }
                                        }}
                                        threshold={[0.5, 1]}
                                      >
                                        <div className="loading-notifications">
                                          ...Loading
                                        </div>
                                      </InView>
                                    )}
                                  </Fragment>
                                ) : (
                                  "There are no notifications"
                                )}
                              </div>
                              <div className={"notification-footer"}>
                                <a
                                  className="mark-all-button"
                                  onClick={() => {
                                    this.setState({
                                      popupText: "mark ALL as read",
                                      isPopupVisible: true,
                                      popupYesAction: () =>
                                        contextState.readAllNotifications(),
                                    });
                                  }}
                                >
                                  Mark all read
                                </a>
                                <a
                                  className="clear-all-button"
                                  onClick={() => {
                                    this.setState({
                                      popupText: "clear all",
                                      isPopupVisible: true,
                                      popupYesAction: () =>
                                        contextState.clearAgencyNotifications(),
                                    });
                                  }}
                                >
                                  Clear All
                                </a>
                              </div>
                            </div>
                            {this.state.isPopupVisible && (
                              <NotificationsModal
                                popupText={this.state.popupText}
                                popupYesAction={async () => {
                                  await this.state.popupYesAction();
                                  this.setState({ isPopupVisible: false });
                                }}
                                popupNoAction={() =>
                                  this.setState({ isPopupVisible: false })
                                }
                              />
                            )}
                          </PopoverBody>
                        </Popover>
                      </Fragment>
                    );
                  }}
                </ActivityLogConsumer>
              </>
            ) : (
              <div className="header-user-information">
                <Link to="/login" className="header-agency-log-in">
                  Log In
                </Link>
              </div>
            )}
            {this.isVisible() && (
              <a
                className="abie-button"
                target="_blank"
                rel="noopener noreferrer"
                href="https://app.schoox.com/7930103/my-commercial-exchange-%28mce%29-system-overview/about?fa=1"
              >
                <img src={getHelp} alt="Need help? Ask ABIe" />
              </a>
            )}
          </div>
        )}
      </div>
    );
  }

  logout() {
    BACKEND_CONFIG.remove("agencyid");
    BACKEND_CONFIG.remove("auth");
    BACKEND_CONFIG.remove("refresh");

    this.setState({ loggedOut: true });
  }
}

export default PageHeader;
